import React from 'react';
import {Header, Stat, Team, TeamImage} from 'app/components/standings/StandingsStyles';
import {Typography} from '@fupa/fupa-uikit';

const StandingsHeader = ({activeTable}) => {
  if (activeTable === 'form') {
    return (
      <Header>
        <Stat align='left' minWidth={24}>
          <Typography variant='caption1'>Pl.</Typography>
        </Stat>
        <TeamImage />
        <Team>
          <Typography variant='caption1'>Team</Typography>
        </Team>
        <Stat align='center' minWidth={56}>
          <Typography variant='caption1'>Letzte 5</Typography>
        </Stat>
        <Stat align='center' minWidth={56}>
          <Typography variant='caption1'>Form*</Typography>
        </Stat>
      </Header>
    );
  } else {
    return (
      <Header>
        <Stat align='left' minWidth={24}>
          <Typography variant='caption1'>Pl.</Typography>
        </Stat>
        <TeamImage />
        <Team>
          <Typography variant='caption1'>Team</Typography>
        </Team>
        <Stat align='center' minWidth={32}>
          <Typography variant='caption1'>Sp.</Typography>
        </Stat>
        <Stat conditional align='center' minWidth={56}>
          <Typography variant='caption1'>S-U-N</Typography>
        </Stat>
        <Stat conditional align='center' minWidth={56}>
          <Typography variant='caption1'>Tore</Typography>
        </Stat>
        <Stat align='center' minWidth={32}>
          <Typography variant='caption1'>Diff.</Typography>
        </Stat>
        <Stat align='center' minWidth={32}>
          <Typography variant='caption1'>Pkt.</Typography>
        </Stat>
      </Header>
    );
  }
};

export default StandingsHeader;
